module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/holes/window-curtain/window.obj";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/holes/window-curtain/window.obj
// module id = 500
// module chunks = 0